/**
 * Dashboard wrapper component file
 *
 * @package    src/components/
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly/dashboard
 */
import React from 'react'

/**
 * Dashboard component function
 *
 * This class will be render all of the children components for dashboard
 * @category  Component
 * @author    YingTuring <ying@turing.com>
 */
const DashboardWrapper = ({ children }) => {
  /**
    * Render function to view this component
    */
  return (
    <div>
      {children}
    </div>
  )
}

export default DashboardWrapper
